// BOLODOO shipping business days v1
(() => {
  if (window.__bolodooNativeFlowerGirlForm) return;
  window.__bolodooNativeFlowerGirlForm = true;

  const rows = [
    { "size": "2", "body": ["98", "53", "51", "51"], "bodyCm": ["38.58", "20.87", "20.08", "20.08"], "floorLength": "78", "floorLengthCm": "30.71", "fiveLength": "57", "fiveLengthCm": "22.44", "sevenLength": "65", "sevenLengthCm": "25.59" },
    { "size": "3", "body": ["104", "55.5", "53.5", "53.5"], "bodyCm": ["40.94", "21.85", "21.06", "21.06"], "floorLength": "82.5", "floorLengthCm": "32.48", "fiveLength": "59.5", "fiveLengthCm": "23.43", "sevenLength": "68.5", "sevenLengthCm": "26.97" },
    { "size": "4", "body": ["110", "58", "56", "56"], "bodyCm": ["43.31", "22.83", "22.05", "22.05"], "floorLength": "87", "floorLengthCm": "34.25", "fiveLength": "62", "fiveLengthCm": "24.41", "sevenLength": "72", "sevenLengthCm": "28.35" },
    { "size": "5", "body": ["115", "61", "58.5", "60"], "bodyCm": ["45.28", "24.02", "23.03", "23.62"], "floorLength": "91.5", "floorLengthCm": "36.02", "fiveLength": "65", "fiveLengthCm": "25.59", "sevenLength": "75.5", "sevenLengthCm": "29.72" },
    { "size": "6", "body": ["120", "64", "61", "64"], "bodyCm": ["47.24", "25.2", "24.02", "25.2"], "floorLength": "96", "floorLengthCm": "37.8", "fiveLength": "68", "fiveLengthCm": "26.77", "sevenLength": "79", "sevenLengthCm": "31.1" },
    { "size": "7", "body": ["125", "66", "62", "66.5"], "bodyCm": ["49.21", "25.98", "24.41", "26.18"], "floorLength": "100.5", "floorLengthCm": "39.57", "fiveLength": "71", "fiveLengthCm": "27.95", "sevenLength": "83", "sevenLengthCm": "32.68" },
    { "size": "8", "body": ["130", "67", "63", "69"], "bodyCm": ["51.18", "26.38", "24.8", "27.17"], "floorLength": "105", "floorLengthCm": "41.34", "fiveLength": "74", "fiveLengthCm": "29.13", "sevenLength": "87", "sevenLengthCm": "34.25" },
    { "size": "9", "body": ["135", "69", "65", "71.5"], "bodyCm": ["53.15", "27.17", "25.59", "28.15"], "floorLength": "109.5", "floorLengthCm": "43.11", "fiveLength": "77.5", "fiveLengthCm": "30.51", "sevenLength": "91", "sevenLengthCm": "35.83" },
    { "size": "10", "body": ["140", "71", "66", "74"], "bodyCm": ["55.12", "27.95", "25.98", "29.13"], "floorLength": "114.5", "floorLengthCm": "45.08", "fiveLength": "81", "fiveLengthCm": "31.89", "sevenLength": "95", "sevenLengthCm": "37.4" },
    { "size": "11", "body": ["145", "73", "67", "78"], "bodyCm": ["57.09", "28.74", "26.38", "30.71"], "floorLength": "118", "floorLengthCm": "46.46", "fiveLength": "83.5", "fiveLengthCm": "32.87", "sevenLength": "98", "sevenLengthCm": "38.58" },
    { "size": "12", "body": ["150", "75", "68", "84"], "bodyCm": ["59.06", "29.53", "26.77", "33.07"], "floorLength": "122", "floorLengthCm": "48.03", "fiveLength": "86", "fiveLengthCm": "33.86", "sevenLength": "101", "sevenLengthCm": "39.76" },
    { "size": "13", "body": ["155", "78", "69.5", "89"], "bodyCm": ["61.02", "30.71", "27.36", "35.04"], "floorLength": "127", "floorLengthCm": "50", "fiveLength": "88", "fiveLengthCm": "34.65", "sevenLength": "104.5", "sevenLengthCm": "41.14" },
    { "size": "14", "body": ["160", "81", "71", "94"], "bodyCm": ["62.99", "31.89", "27.95", "37.01"], "floorLength": "132", "floorLengthCm": "51.97", "fiveLength": "90", "fiveLengthCm": "35.43", "sevenLength": "108", "sevenLengthCm": "42.52" },
  ];
  const bodyHeaders = ["Height", "Bust", "Waist", "Hips"];
  const lengthHeaders = ["Floor length", "5/10 length", "7/10 length"];
  const productionTime = [7, 12];
  const shippingTime = { standard: [5, 12], expedited: [3, 5] };
  const addDays = (date, days) => { const result = new Date(date.getTime()); result.setUTCDate(result.getUTCDate() + days); return result; };
  const formatDate = (date) => date.toLocaleString("en-US", { month: "short", timeZone: "UTC" }) + ". " + date.getUTCDate();
  const formatRange = (start, min, max) => formatDate(addDays(start, min)) + " - " + formatDate(addDays(start, max));
  const addBusinessDays = (date, days) => {
    const result = new Date(date.getTime());
    while (days > 0) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6) days -= 1;
    }
    return result;
  };
  const deliveryRange = (start, shipping) => formatDate(addBusinessDays(addDays(start, productionTime[0]), shipping[0])) + " - " + formatDate(addBusinessDays(addDays(start, productionTime[1]), shipping[1]));
  const getDeliveryEstimate = () => {
    const now = new Date();
    const start = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
    return {
      tailoring: productionTime[0] + "-" + productionTime[1] + " Days",
      standard: deliveryRange(start, shippingTime.standard),
      expedited: deliveryRange(start, shippingTime.expedited),
    };
  };

  document.querySelectorAll("[data-fgd-root]:not([data-fgd-ready])").forEach((root) => {
    root.setAttribute("data-fgd-ready", "");
    const drawer = root.querySelector("[data-fgd-drawer]");
    const chartDrawer = root.querySelector("[data-fgd-chart-drawer]");
    const scrim = root.querySelector("[data-fgd-backdrop]");
    const sizeGrid = root.querySelector("[data-fgd-size-grid]");
    const preview = root.querySelector("[data-fgd-preview]");
    const chartBodies = {
      body: root.querySelector('[data-fgd-chart-body="body"]'),
      length: root.querySelector('[data-fgd-chart-body="length"]'),
    };
    const confirm = root.querySelector("[data-fgd-confirm]");
    const propertyInputs = {
      size: root.querySelector('[data-fgd-cart-property="size"]'),
      measurements: root.querySelector('[data-fgd-cart-property="measurements"]'),
      tailoringTime: root.querySelector('[data-fgd-cart-property="tailoring-time"]'),
      standardDelivery: root.querySelector('[data-fgd-cart-property="standard-delivery"]'),
      expeditedDelivery: root.querySelector('[data-fgd-cart-property="expedited-delivery"]'),
    };
    const portal = document.createElement("div");
    portal.className = "fgd__portal";
    document.body.append(portal);
    portal.append(scrim, drawer, chartDrawer);
    let selectedSize = "";
    let unit = "inch";

    const selectedRow = () => rows.find((row) => row.size === selectedSize);
    const getProductForm = () => {
      const scope = root.closest(".product__info-container") || root.closest('[id^="ProductInfo-"]') || document;
      return scope.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[data-type="add-to-cart-form"]');
    };
    const valuesFor = (row, type) => {
      const displayValue = (value) => {
        const rounded = Math.round(Number(value) * 2) / 2;
        return unit === "cm" ? value : rounded;
      };
      if (type === "body") return (unit === "cm" ? row.body : row.bodyCm).map(displayValue);
      return (unit === "cm" ? [row.floorLength, row.fiveLength, row.sevenLength] : [row.floorLengthCm, row.fiveLengthCm, row.sevenLengthCm]).map(displayValue);
    };
    const suffix = () => unit === "cm" ? " cm" : " inch";
    const measurementsFor = (row) => [
      "Height: " + valuesFor(row, "body")[0] + suffix(),
      "Bust: " + valuesFor(row, "body")[1] + suffix(),
      "Waist: " + valuesFor(row, "body")[2] + suffix(),
      "Hips: " + valuesFor(row, "body")[3] + suffix(),
      "Floor Length: " + valuesFor(row, "length")[0] + suffix(),
      "5/10 Length: " + valuesFor(row, "length")[1] + suffix(),
      "7/10 Length: " + valuesFor(row, "length")[2] + suffix(),
    ].join("; ");
    const syncCartProperties = () => {
      const row = selectedRow();
      const estimate = getDeliveryEstimate();
      propertyInputs.size.value = row ? row.size : "";
      propertyInputs.measurements.value = row ? measurementsFor(row) : "";
      propertyInputs.tailoringTime.value = estimate.tailoring;
      propertyInputs.standardDelivery.value = estimate.standard;
      propertyInputs.expeditedDelivery.value = estimate.expedited;
      const form = getProductForm();
      if (form) Object.values(propertyInputs).forEach((input) => form.append(input));
    };
    const renderDelivery = () => {
      const estimate = getDeliveryEstimate();
      root.querySelector("[data-fgd-tailoring]").textContent = estimate.tailoring;
      root.querySelector("[data-fgd-standard-date]").textContent = estimate.standard;
      root.querySelector("[data-fgd-expedited-date]").textContent = estimate.expedited;
      root.querySelector("[data-fgd-standard-time]").textContent = shippingTime.standard[0] + "-" + shippingTime.standard[1] + " Business Days";
      root.querySelector("[data-fgd-expedited-time]").textContent = shippingTime.expedited[0] + "-" + shippingTime.expedited[1] + " Business Days";
    };
    const renderRows = (items, type) => items.map((row) => {
      const values = valuesFor(row, type);
      return '<tr class="' + (row.size === selectedSize ? "is-selected" : "") + '"><th scope="row">' + row.size + '</th>' + values.map((value) => '<td>' + value + suffix() + '</td>').join("") + '</tr>';
    }).join("");
    const renderTable = (items, type, title) => '<section class="fgd__measurement-group"><h4>' + title + '</h4><div class="fgd__table-scroll"><table class="fgd__table"><thead><tr><th>Size</th>' + (type === "body" ? bodyHeaders : lengthHeaders).map((header) => '<th>' + header + '</th>').join("") + '</tr></thead><tbody>' + renderRows(items, type) + '</tbody></table></div></section>';
    const renderPreview = () => {
      if (!selectedSize) {
        preview.innerHTML = '<p class="fgd__preview-empty">Select a size to view body measurements and dress length.</p>';
        return;
      }
      const index = rows.findIndex((row) => row.size === selectedSize);
      const visibleRows = rows.slice(Math.max(0, index - 1), Math.min(rows.length, index + 2));
      preview.innerHTML = '<h3>Size measurements</h3>' + renderTable(visibleRows, "body", "Body measurements") + renderTable(visibleRows, "length", "Dress length");
    };
    const render = () => {
      renderDelivery();
      sizeGrid.innerHTML = rows.map((row) => '<button type="button" class="fgd__size-option" data-fgd-size="' + row.size + '" aria-pressed="' + (row.size === selectedSize) + '">Size ' + row.size + '</button>').join("");
      confirm.disabled = !selectedSize;
      renderPreview();
      chartBodies.body.innerHTML = renderRows(rows, "body");
      chartBodies.length.innerHTML = renderRows(rows, "length");
      root.querySelector('[data-fgd-selector-label]').textContent = selectedSize ? "Size " + selectedSize : "Select A Size";
    };
    const close = () => {
      drawer.dataset.open = "false";
      chartDrawer.dataset.open = "false";
      drawer.setAttribute("aria-hidden", "true");
      chartDrawer.setAttribute("aria-hidden", "true");
      drawer.hidden = true;
      chartDrawer.hidden = true;
      scrim.hidden = true;
      document.body.classList.remove("fgd-open");
    };
    const open = (panel) => {
      drawer.hidden = panel !== drawer;
      chartDrawer.hidden = panel !== chartDrawer;
      drawer.dataset.open = panel === drawer ? "true" : "false";
      chartDrawer.dataset.open = panel === chartDrawer ? "true" : "false";
      drawer.setAttribute("aria-hidden", String(panel !== drawer));
      chartDrawer.setAttribute("aria-hidden", String(panel !== chartDrawer));
      scrim.hidden = false;
      document.body.classList.add("fgd-open");
      panel.querySelector("button")?.focus();
    };
    const enforceRequiredSize = (event) => {
      syncCartProperties();
      if (selectedSize) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      root.querySelector("[data-fgd-cart-error]").hidden = false;
      open(drawer);
    };

    root.querySelector("[data-fgd-open]").addEventListener("click", () => open(drawer));
    document.addEventListener("click", (event) => {
      if (!root.contains(event.target) && !drawer.contains(event.target) && !chartDrawer.contains(event.target) && event.target !== scrim) return;
      const size = event.target.closest("[data-fgd-size]");
      if (size) { selectedSize = size.dataset.fgdSize; root.querySelector("[data-fgd-cart-error]").hidden = true; syncCartProperties(); render(); }
      if (event.target.closest("[data-fgd-close]") || event.target.closest("[data-fgd-chart-close]") || event.target === scrim) close();
      if (event.target.closest("[data-fgd-confirm]") && selectedSize) { syncCartProperties(); close(); }
      if (event.target.closest("[data-fgd-view-chart]")) open(chartDrawer);
      const unitButton = event.target.closest("[data-fgd-unit]");
      if (unitButton) { unit = unitButton.dataset.fgdUnit; root.querySelectorAll("[data-fgd-unit]").forEach((button) => button.setAttribute("aria-pressed", String(button === unitButton))); syncCartProperties(); render(); }
    });
    document.addEventListener("submit", (event) => {
      const form = getProductForm();
      if (form && event.target === form) enforceRequiredSize(event);
    }, true);
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && (drawer.dataset.open === "true" || chartDrawer.dataset.open === "true")) close();
    });
    render();
    syncCartProperties();
  });
})();
